import {FC} from 'react';
import {ArchiveCheckbox} from '../../../../../ArchiveCheckbox';
import {useDashboardTabsStore} from '../../store/useDashboardTabsStore';
import {useStoresContext} from '../../hooks/useStoresContext';
import {useStore} from 'zustand';
import {Stack} from '@mui/material';
import {DashboardTypes} from '../../../../../../shared/types/dashboard.types';

export const DashboardArchiveCheckbox: FC = () => {
  const {activeTab} = useDashboardTabsStore();
  const {dashboardTypeStore, dashboardArchiveFilterStore, serviceRequestsArchiveFilterStore} =
    useStoresContext(activeTab);
  const {dashboardType} = useStore(dashboardTypeStore);
  const isRequestsStatuses = dashboardType === DashboardTypes.REQUESTS_STATUSES;
  const dashboardArchive = useStore(dashboardArchiveFilterStore);
  const serviceRequestsArchive = useStore(serviceRequestsArchiveFilterStore);
  const archived = isRequestsStatuses ? serviceRequestsArchive.archived : dashboardArchive.archived;
  const setArchived = isRequestsStatuses ? serviceRequestsArchive.setArchived : dashboardArchive.setArchived;

  return (
    <Stack pr={2} bgcolor="#fff" borderRadius={1}>
      <ArchiveCheckbox
        label="Отображать архивные контракты"
        checked={archived}
        onChange={(_, checked) => setArchived(checked)}
      />
    </Stack>
  );
};
